class ConfiguratorAppointmentCalendar extends HTMLElement {
    constructor() {
      super();
  
      this.drawer = document.querySelector('configurator-drawer');
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('button[type="submit"]');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.possibleNextSteps = ['appointment-personal-info'];
      this.nextStepsHtml = {};
      this.previousStepHtml = undefined;
      this.getNextSteps();
      this.getPreviousSteps();
      this.timeScheduleContainer = this.querySelector('#time_schedule');
  
      if (!this.drawer.appointment.location) this.renderPreviousStep();
  
      this.insertLocationValues(this.drawer.appointment.location);
      this.calendar = this.initCalendar();
    }
  
    getFormValue() {
      const formData = new FormData(this.form);
      return [...formData.entries()];
    }
  
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
  
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
  
      const formData = new FormData(this.form);
  
      this.renderNextStep('quality');
    }
  
    getLocations(q) {
      if (!q) return;
  
      return [
        {
          name: 'Optik Lotz GmbH',
          street: 'Große Marktstraße 16',
          zip: '63065',
          city: 'Offenbach am Main',
          distance: 5.5,
        },
        {
          name: 'GUCK - Optik',
          street: 'Bieberer Straße 18',
          zip: '63065',
          city: 'Offenbach am Main',
          distance: 5.7,
        },
        {
          name: 'Jung Optik',
          street: 'Kaiserstraße 63',
          zip: '63065',
          city: 'Offenbach am Main',
          distance: 6.2,
        },
        {
          name: 'Oliver Münning',
          street: 'Offenbacher Landstraße 315',
          zip: '60599',
          city: 'Frankfurt am Main',
          distance: 9.2,
        },
        {
          name: 'Art-Optik Batschari',
          street: 'Berger Straße 62',
          zip: '60316',
          city: 'Frankfurt am Main',
          distance: 9.7,
        },
        {
          name: 'Friedauer Optik',
          street: 'Berger Straße 189',
          zip: '60385',
          city: 'Frankfurt am Main',
          distance: 10.1,
        },
      ];
    }
  
    createElement(type, content = '', cssClass = false) {
      const element = document.createElement(type);
      if (cssClass) element.classList.add(cssClass);
      element.textContent = content;
      return element;
    }
  
    insertLocationValues(location) {
      const distanceValue = `${location.distance.toLocaleString('de-DE', { minimumFractionDigits: 1 })} km`;
      const locationElement = this.querySelector('.drawer__form_option.scheduled.location');
      locationElement.querySelector('.location_name').textContent = location.name;
      locationElement.querySelector('.location_street').textContent = location.street;
      locationElement.querySelector('.location_zip').textContent = location.zip;
      locationElement.querySelector('.location_city').textContent = location.city;
      locationElement.querySelector('.location_distance').textContent = distanceValue;
  
      locationElement.addEventListener('click', () => this.renderPreviousStep());
    }
  
    onSearchLocationHandler() {
      // clear first
      this.form.querySelectorAll('.drawer__form_option').forEach((location) => location.remove());
  
      const q = document.querySelector('.appointment_search input').value;
      const locations = this.getLocations(q);
  
      if (!locations) return;
  
      locations.forEach((location) => {
        const locationElement = this.generateLocationElement(location);
        const locationJsonString = JSON.stringify(location);
        locationElement.dataset.locationInfo = locationJsonString;
  
        this.form.appendChild(locationElement);
  
        locationElement.addEventListener('click', () => this.onLocationClickHandler(locationElement));
      });
    }
  
    onLocationClickHandler(location) {
      const locationInfoJson = JSON.parse(location.dataset.locationInfo);
      this.drawer.appointment['location'] = locationInfoJson;
  
      this.renderNextStep('appointment-calendar');
    }
  
    generateLocationElement(location) {
      const locationSvg = document.querySelector('.appointment_search .my_location svg');
      const distanceValue = `${location.distance.toLocaleString('de-DE', { minimumFractionDigits: 1 })} km`;
  
      const locationWrapper = this.createElement('div', '', 'drawer__form_option');
      const leftContainer = this.createElement('div', '', 'location_info');
      const rightContainer = this.createElement('div', '', 'location_position');
      const locationName = this.createElement('b', location.name, 'location_name');
      const locationStreet = this.createElement('span', location.street, 'location_street');
      const locationZip = this.createElement('span', location.zip, 'location_zip');
      const locationCity = this.createElement('span', location.city, 'location_city');
      const locationDistance = this.createElement('span', distanceValue, 'location_distance');
      const locationOrt = this.createElement('span');
  
      locationOrt.appendChild(locationZip);
      locationOrt.appendChild(locationCity);
  
      leftContainer.appendChild(locationName);
      leftContainer.appendChild(locationStreet);
      leftContainer.appendChild(locationOrt);
  
      rightContainer.appendChild(locationSvg.cloneNode(true));
      rightContainer.appendChild(locationDistance);
  
      locationWrapper.appendChild(leftContainer);
      locationWrapper.appendChild(rightContainer);
  
      return locationWrapper;
    }
  
    initCalendar() {
      const calendarContainer = this.querySelector('#calendar');
      const todayDate = new Date();
      const yesterdayDate = new Date(todayDate.setDate(todayDate.getDate() - 1));
      const formattedYesterdayDate = yesterdayDate.toISOString().split('T')[0];
  
      const appointmentCalendar = this;
      const { Calendar } = window.VanillaCalendarPro;
      const calendar = new Calendar(calendarContainer, {
        locale: 'de-DE',
        selectedTheme: 'light',
        disableDates: [`1970-01-01:${formattedYesterdayDate}`, '2022-08-22'],
        onClickDate() {
          const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
          const selectedDateString = this.context.selectedDates[0];
          const selectedDateInSeconds = Date.parse(selectedDateString);
          const selectedDate = new Date(selectedDateInSeconds).toLocaleDateString('de-DE', options);
  
          appointmentCalendar.drawer.appointment.date = selectedDate;
          appointmentCalendar.renderTimeSchedule();
        },
      });
      calendar.init();
  
      return calendar;
    }
  
    renderTimeSchedule() {
      const appointmentTimes = [
        '10:00',
        '10:30',
        '11:00',
        '11:30',
        '12:00',
        '12:30',
        '13:00',
        '13:30',
        '14:00',
        '14:30',
        '15:00',
        '15:30',
        '16:00',
        '16:30',
        '17:00',
        '17:30',
      ];
  
      // reset content
      this.timeScheduleContainer.innerHTML = '';
  
      appointmentTimes.forEach((time) => {
        const timeElement = this.generateTimeElement(time);
        this.timeScheduleContainer.appendChild(timeElement);
      });
    }
  
    generateTimeElement(time) {
      const timeElement = document.createElement('div');
      timeElement.classList.add('time');
      timeElement.textContent = time;
      timeElement.dataset.time = time;
      timeElement.dataset.available = Math.random() < 0.5;
      timeElement.addEventListener('click', () => this.onTimeClickHandler(timeElement));
  
      return timeElement;
    }
  
    onTimeClickHandler(timeElement) {
      this.querySelectorAll('.time[data-selected]').forEach((selectedTimeElement) => {
        selectedTimeElement.removeAttribute('data-selected');
      });
      timeElement.setAttribute('data-selected', '');
      this.drawer.appointment.time = timeElement.dataset.time;
  
      this.calendar.destroy();
      this.renderNextStep('appointment-personal-info');
    }
  
    getNextSteps() {
      const sections = [];
      this.possibleNextSteps.forEach((step) => sections.push('configurator-' + step));
      const url = '?sections=' + sections.join(',');
  
      fetch(url)
        .then((response) => response.json())
        .then((response) => {
          this.possibleNextSteps.forEach((step) => {
            this.nextStepsHtml[step] = response[`configurator-${step}`];
          });
        })
        .catch((e) => {
          console.error(e);
        });
    }
  
    getPreviousSteps() {
      fetch('?sections=configurator-appointment-location')
        .then((response) => response.json())
        .then((response) => {
          this.previousStepHtml = response['configurator-appointment-location'];
        })
        .catch((e) => {
          console.error(e);
        });
    }
  
    renderPreviousStep() {
      if (!this.previousStepHtml) return;
  
      this.drawer.renderContents(this.previousStepHtml);
    }
  
    renderNextStep(nextStep) {
      this.drawer.renderContents(this.nextStepsHtml[nextStep]);
    }
  }
  
  customElements.define('configurator-appointment-calendar', ConfiguratorAppointmentCalendar);
  